module.exports = __webpack_public_path__ + "img/CALL.69da0cfc.svg";